import * as React from "react";
import { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { PaginatedItemOverview, ShareButton } from "components/common";
import SectionComponent from "components/common/Section/SectionComponent";
import UsersQueryHelper from "components/users/UsersQueryHelper";
import EntityShareModal from "components/permissions/EntityShareModal";
import UserItemComponent from "./UsersSection/UserItemComponent";
import TeamsDomain from "../../domainActions/TeamsDomain";
const UsersSection = ({ team: { id, name } }) => {
  const { t } = useTranslation("enterprise_security");
  const [showShareModal, setShowShareModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const usersQueryHelper = /* @__PURE__ */ React.createElement(UsersQueryHelper, null);
  const _onLoad = useCallback(
    (pagination) => {
      setLoading(true);
      return TeamsDomain.loadUsersForTeam(id, name, pagination).then((paginatedUsers) => {
        setLoading(false);
        return paginatedUsers;
      });
    },
    [id, name]
  );
  return /* @__PURE__ */ React.createElement(
    SectionComponent,
    {
      title: t("team_details_users.title"),
      showLoading: loading,
      headerActions: /* @__PURE__ */ React.createElement(ShareButton, { entityId: id, entityType: "team_users", onClick: () => setShowShareModal(true) })
    },
    /* @__PURE__ */ React.createElement(
      PaginatedItemOverview,
      {
        noDataText: t("team_details_users.no_data"),
        onLoad: _onLoad,
        queryHelper: usersQueryHelper,
        overrideItemComponent: UserItemComponent
      }
    ),
    showShareModal && /* @__PURE__ */ React.createElement(
      EntityShareModal,
      {
        entityId: id,
        entityType: "team_users",
        entityTypeTitle: t("team_details_users.entity_type_title"),
        entityTitle: name,
        description: t("team_details_users.share_description"),
        onClose: () => setShowShareModal(false)
      }
    )
  );
};
export default UsersSection;
